import React, { useState, useEffect } from 'react';

const Timer = ({ initialTime,isSidebarVisible }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: parseInt(initialTime?.days),
        hours: parseInt(initialTime?.hrs),
        minutes: parseInt(initialTime?.mins),
      });
    
      // Function to handle countdown logic (decrement by 1 minute)
      const updateCountdown = () => {
        setTimeLeft(prev => {
          let { days, hours, minutes } = prev;
    
          if (minutes > 0) {
            minutes--;
          } else {
            if (hours > 0) {
              hours--;
              minutes = 59;
            } else {
              if (days > 0) {
                days--;
                hours = 23;
                minutes = 59;
              }
            }
          }
    
          return { days, hours, minutes };
        });
      };
    
      useEffect(() => {
        // Run the countdown only when the sidebar is visible
        if (!isSidebarVisible) return; // Don't run the countdown if sidebar is hidden
    
        const interval = setInterval(() => {
          updateCountdown();
        }, 60000); // Update every minute
    
        // Cleanup the interval when the component unmounts or when the sidebar is hidden
        return () => clearInterval(interval);
      }, [isSidebarVisible]); // Only restart the interval when visibility changes
    
  return (
      <>
        {timeLeft?.days > 0 && <span>{timeLeft.days}d </span>}
        {timeLeft.hours > 0 || timeLeft.days > 0 ? <span>{timeLeft.hours}h </span> : null}
        {timeLeft.minutes > 0 || timeLeft.hours > 0 || timeLeft.days > 0 ? <span>{timeLeft.minutes}m </span> : null}
      </>
  );
};


export default Timer;
